import React from "react";

export const Section = ({ children, className = "", tone = "paper" }) => (
  <section
    className={`bg-dotgrid ${tone === "panel" ? "bg-panel" : "bg-paper"} ${className}`}
  >
    <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28">{children}</div>
  </section>
);

export const Eyebrow = ({ children }) => (
  <p className="mb-4 flex items-center gap-2 font-mono text-xs font-medium uppercase tracking-[0.18em] text-accent">
    <span className="inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-accent" aria-hidden="true" />
    {children}
  </p>
);

export const Tag = ({ children }) => (
  <span className="inline-flex items-center rounded-full border border-line bg-paper px-3 py-1 font-mono text-xs font-medium text-ink-soft">
    {children}
  </span>
);
